<template>
  <v-container fluid>
    <h2 class="mb-4">TURTAS XSD schemos ir elementų aprašai</h2>
    <v-data-table
      :headers="filteredHeaders"
      :items="filteredItems"
      hide-default-footer
      disable-pagination
    >
      <template #[`item.aprasas`]="{ item }">
        <el-button
          small
          @click.native="openDescription(item)"
          v-if="item.pdfFile"
        >
          {{ item.pdfName }}
        </el-button>
      </template>
      <template #[`item.schema`]="{ item }">
        <el-button small @click.native="openSchema(item)" v-if="item.xsdFile">
          {{ item.xsdName }}
        </el-button>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import math from '../mixins/math'
export default {
  name: 'XSDSchemaList',
  mixins: [math],
  data() {
    return {
      //
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Eil. Nr.',
          align: 'center',
          value: 'eil_nr',
          width: 100,
        },
        {
          text: 'XSD specifikacija (elementų aprašai)',
          align: 'start',
          value: 'aprasas',
        },
        {
          text: 'XSD schema',
          align: 'start',
          value: 'schema',
        },
        {
          text: 'Versija',
          align: 'center',
          value: 'version',
          width: 100,
        },
        {
          text: 'Data nuo',
          align: 'center',
          value: 'dateFrom',
        },
        {
          text: 'Data iki',
          align: 'center',
          value: 'dateTo',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    items() {
      return [
        // v1.1
        {
          pdfName: 'NTR STSR hipoteka DMNTeikimasXML išsami',
          pdfFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.1_issami.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.1_issami.xsd',
          version: 'v1.1',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        {
          pdfName: 'NTR STSR hipoteka DMNTeikimasXML patikra',
          pdfFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.1_patikra.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.1_patikra.xsd',
          version: 'v1.1',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        {
          pdfName: 'NTR STSR hipoteka sutartis DMNTeikimasXML sąrašas',
          pdfFile: 'NTR_STSR_hipoteka_sutartis_DMNTeikimasXML_v1.1_sarasas.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_hipoteka_sutartis_DMNTeikimasXML_v1.1_sarasas.xsd',
          version: 'v1.1',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        {
          pdfName: 'NTR STSR sutartis DMNTeikimasXML išsami',
          pdfFile: 'NTR_STSR_sutartis_DMNTeikimasXML_v1.1_issami.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_sutartis_DMNTeikimasXML_v1.1_issami.xsd',
          version: 'v1.1',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        {
          pdfName: 'STSR DMNTeikimasSusijusiemsXML',
          pdfFile: 'STSR_DMNTeikimasSusijusiemsXML_v1.1.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'STSR_DMNTeikimasSusijusiemsXML_v1.1.xsd',
          version: 'v1.1',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        // v1.0
        {
          pdfName: 'NTR STSR hipoteka DMNTeikimasXML išsami su istorija',
          pdfFile:
            'NTR_STSR_hipoteka_DMNTeikimasXML_issami_su_istorija_v1.0.pdf',
          xsdName: 'XSD schema',
          xsdFile:
            'NTR_STSR_hipoteka_DMNTeikimasXML_issami_su_istorija_v1.0.xsd',
          version: 'v1.0',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        {
          pdfName: 'NTR STSR sutartis DMNTeikimasXML išsami su istorija',
          pdfFile:
            'NTR_STSR_sutartis_DMNTeikimasXML_issami_su_istorija_v1.0.pdf',
          xsdName: 'XSD schema',
          xsdFile:
            'NTR_STSR_sutartis_DMNTeikimasXML_issami_su_istorija_v1.0.xsd',
          version: 'v1.0',
          dateFrom: '2024-03-27',
          dateTo: '',
        },
        {
          pdfName: 'NTR STSR hipoteka DMNTeikimasXML išsami',
          pdfFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.0_issami.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.0_issami.xsd',
          version: 'v1.0',
          dateFrom: '2022-01-01',
          dateTo: '2024-03-26',
        },
        {
          pdfName: 'NTR STSR hipoteka DMNTeikimasXML patikra',
          pdfFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.0_patikra.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_hipoteka_DMNTeikimasXML_v1.0_patikra.xsd',
          version: 'v1.0',
          dateFrom: '2022-01-01',
          dateTo: '2024-03-26',
        },
        {
          pdfName: 'NTR STSR hipoteka sutartis DMNTeikimasXML sąrašas',
          pdfFile: 'NTR_STSR_hipoteka_sutartis_DMNTeikimasXML_v1.0_sarasas.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_hipoteka_sutartis_DMNTeikimasXML_v1.0_sarasas.xsd',
          version: 'v1.0',
          dateFrom: '2022-01-01',
          dateTo: '2024-03-26',
        },
        {
          pdfName: 'NTR STSR sutartis DMNTeikimasXML išsami',
          pdfFile: 'NTR_STSR_sutartis_DMNTeikimasXML_v1.0_issami.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'NTR_STSR_sutartis_DMNTeikimasXML_v1.0_issami.xsd',
          version: 'v1.0',
          dateFrom: '2022-01-01',
          dateTo: '2024-03-26',
        },
        {
          pdfName: 'STSR DMNTeikimasSusijusiemsXML',
          pdfFile: 'STSR_DMNTeikimasSusijusiemsXML_v1.0.pdf',
          xsdName: 'XSD schema',
          xsdFile: 'STSR_DMNTeikimasSusijusiemsXML_v1.0.xsd',
          version: 'v1.0',
          dateFrom: '2022-01-01',
          dateTo: '2024-03-26',
        },
      ]
    },
    filteredItems() {
      let eil_nr = 1
      return this.items.filter(item => {
        item.eil_nr = eil_nr++
        return !item.hide
      })
    },
  },
  created() {
    //
  },
  methods: {
    openSchema(item) {
      const file = `xsdschema/${item.version}/${item.xsdFile}`
      const fileName = `${item.xsdFile}`
      this.downloadFile(file, fileName)
    },
    openDescription(item) {
      const file = `xmldescription/${item.version}/${item.pdfFile}`
      const fileName = `${item.pdfFile}`
      this.downloadFile(file, fileName)
    },
    downloadFile(file, fileName) {
      this.$axios
        .get(file, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          this.openFile(res.data, fileName)
        })
        .catch(err => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.errormsg = errData.message
        })
    },
    openFile(fileData, fileName) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', this.safeFileName(fileName))
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
